import moment from "moment";

class CreatedAt {
  constructor(private readonly _value: moment.Moment = moment()) {}
  public toString(): string {
    return this._value.format("YYYY/MM/DD");
  }
}

export default CreatedAt;
